// extracted by mini-css-extract-plugin
export default {"wrapper":"Jd","form":"Kd","preference":"Ld","request":"Md","job":"Nd","smallprint":"Od","asterisk":"Pd","success":"Qd","circle":"Rd"};